type AlertProps = {
  type?: 'error' | 'success';
  children: React.ReactNode;
};

export default function Alert({ type = 'error', children }: AlertProps) {
  const styles =
    type === 'success'
      ? 'bg-moss/10 border-moss text-moss-dark'
      : 'bg-rust/10 border-rust text-rust';

  return (
    <div className={`rounded-rustic border px-3 py-2 text-sm ${styles}`} role="status">
      {children}
    </div>
  );
}
